import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

// event domain 으로 만든 api eventapi.sooplive.co.kr x 아닙니다.
const ItemMobileApi = ApiCore(globalDomains.ITEM_M_AFREECATV);
export default ItemMobileApi;
